// Vue Components Index
// Import and register all Vue components here

// Production components
import EmployeeCreate from './EmployeeCreate.vue';
import CustomerCreate from './CustomerCreate.vue';
import SalesForm from './SalesForm.vue';
import SupplierCreate from './SupplierCreate.vue';
import PurchaseOrderForm from './PurchaseOrderForm.vue';
import SaleReturnForm from './SaleReturnForm.vue';
import PurchaseReturnForm from './PurchaseReturnForm.vue';
import WithdrawIncome from './WithdrawIncome.vue';
import ProductCreate from './ProductCreate.vue';
import ShopCreate from './ShopCreate.vue';
import OrderCreate from './OrderCreate.vue';
import OrderPayment from './OrderPayment.vue';
import OrderCancel from './OrderCancel.vue';
import OrderConfirm from './OrderConfirm.vue';
import OrderDelivery from './OrderDelivery.vue';
import CustomerPayment from './CustomerPayment.vue';
import SupplierPayment from './SupplierPayment.vue';
import ExpenseManager from './ExpenseManager.vue';
import AdminExpenseCreate from './AdminExpenseCreate.vue';
import ExpenseCategoryManager from './ExpenseCategoryManager.vue';
import AdminCashAdd from './AdminCashAdd.vue';

// Example component imports (you'll add these as you create components)
// import ProductCreate from './ProductCreate.vue';

// Register components function
export function registerAllComponents() {
    // Register test component
    // Register production components
    window.registerVueComponent('EmployeeCreate', EmployeeCreate);
    window.registerVueComponent('CustomerCreate', CustomerCreate);
    window.registerVueComponent('SalesForm', SalesForm);
    window.registerVueComponent('SupplierCreate', SupplierCreate);
    window.registerVueComponent('PurchaseOrderForm', PurchaseOrderForm);
    window.registerVueComponent('SaleReturnForm', SaleReturnForm);
    window.registerVueComponent('PurchaseReturnForm', PurchaseReturnForm);
    window.registerVueComponent('WithdrawIncome', WithdrawIncome);
    window.registerVueComponent('ProductCreate', ProductCreate);
    window.registerVueComponent('ShopCreate', ShopCreate);
    window.registerVueComponent('OrderCreate', OrderCreate);
    window.registerVueComponent('OrderPayment', OrderPayment);
    window.registerVueComponent('OrderCancel', OrderCancel);
    window.registerVueComponent('OrderConfirm', OrderConfirm);
    window.registerVueComponent('OrderDelivery', OrderDelivery);
    window.registerVueComponent('CustomerPayment', CustomerPayment);
    window.registerVueComponent('SupplierPayment', SupplierPayment);
    window.registerVueComponent('ExpenseManager', ExpenseManager);
    window.registerVueComponent('AdminExpenseCreate', AdminExpenseCreate);
    window.registerVueComponent('ExpenseCategoryManager', ExpenseCategoryManager);
    window.registerVueComponent('AdminCashAdd', AdminCashAdd);

    // Register other components globally
    // window.registerVueComponent('ProductCreate', ProductComponent);

    console.log('All Vue components registered');
}

// Auto-register components when this module is imported
registerAllComponents();
